<template>
    <div class="AddInfoNewsWarp">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="addnewseForm">
            <el-row :gutter="20">
                <div class="formtop">
                    <el-col :span="10">
                        <div>
                            <el-form-item label="标题图片" prop="titleImgUrl">
                                <!--  :on-success="handleAvatarSuccess" -->
                                <!-- :show-file-list="false" -->
                                <el-upload id="imgupload" class="avatar-uploader" accept=".jpg,.png,.jpeg" list-type="picture-card" :on-remove="handleRemove"
                                    :action="actionUrl" :headers="header" :limit="1" :file-list="imgfileList" :on-change="changePhotoFile"
                                    :auto-upload="false" :show-file-list="showImg">
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="14">
                        <div>
                            <el-form-item label="发布时间" prop="pressTime">
                                <el-date-picker v-model="ruleForm.pressTime" type="date" placeholder="请选择发布时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                    style="width:100%" :picker-options="pickerOptions">
                                </el-date-picker>
                            </el-form-item>
                            <!-- <el-row>
                                 <el-form-item label="发布时间" prop="pressTime">
                                <el-col :span="12">
                                    <el-date-picker v-model="ruleForm.pressTime" type="date" placeholder="请选择发布日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                    style="width:100%" :picker-options="pickerOptions">
                                </el-date-picker>
                                </el-col>
                                <el-col :span="12">
                                     <el-time-picker placeholder="选择具体时间" v-model="ruleForm.date2" format="HH-mm-ss" value-format="HH-mm-ss" style="width: 100%;"></el-time-picker>
                                </el-col>
                                </el-form-item>
                            </el-row> -->

                        </div>
                        <div>
                            <el-form-item label="发布栏目" prop="pressSuperClass">
                                <el-select v-model="ruleForm.pressSuperClass" placeholder="请选择发布栏目" style="width:100%">
                                    <el-option v-for="item in pressSuperClassArr" :key="item.key" :label="item.title" :value="item.key"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="创建者(来源)" prop="pressSource">
                                <el-input v-model="ruleForm.pressSource"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </div>
            </el-row>

            <el-row :gutter="20">
                <!-- <el-col :span="12">
                    <el-form-item label="是否发布到首页 " prop="resource">
                        <el-radio-group v-model="ruleForm.resource">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col> -->
                <el-col :span="12">
                    <el-form-item label="附件上传" prop="downloadAttachment">
                        <el-upload accept=".doc,.docx,.xls,.xlsx" multiple :on-success="handlefileSuccess" :on-remove="handlefileRemove" :action="actionUrl"
                            :headers="header" :file-list="fileList">
                            <i class="el-icon-upload"></i>
                        </el-upload>
                        <!-- <el-upload class="upload-demo" :action="actionUrl" :on-success="handlefileSuccess" :on-remove="handlefileRemove" multiple
                            :limit="1" :on-exceed="handleExceed" :file-list="fileList" :headers="header" accept=".doc,.docx,.xls,.xlsx">
                            <i class="el-icon-upload"></i>
                        </el-upload> -->
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="标题" prop="pressTopic">
                        <el-input v-model="ruleForm.pressTopic"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="简介" prop="synopsis">
                        <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="ruleForm.synopsis">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="新闻内容" prop="content">
                        <div class="edithome">
                            <div id="edit"></div>
                            <!-- <button type="button" class="btn" @click="getEditorData">获取当前内容</button> -->
                            <!-- <h3>内容预览</h3>
                            <textarea name="" id="" cols="170" rows="20" readonly v-model="editorData"></textarea> -->
                        </div>

                    </el-form-item>
                </el-col>
            </el-row>

            <div class="handleBox">
                <el-button @click="previewFn">预览</el-button>
                <el-button @click="draftForm('ruleForm')">暂存至草稿</el-button>
                <el-button @click="submitForm('ruleForm')">提交发布</el-button>
                <!-- <el-button @click="returnListFn">返回列表</el-button> -->
            </div>
        </el-form>
        <!-- vueCropper 剪裁图片实现-->
        <el-dialog title="图片剪裁" :visible.sync="dialogVisible" class="crop-dialog" append-to-body :close-on-click-modal="false" :close-on-press-escape='false'
            :show-close="false">
            <div class="cropper-content">
                <div class="cropper" style="text-align:center">
                    <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType" :info="true" :full="option.full"
                        :canMove="option.canMove" :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop"
                        :fixed="option.fixed" :fixedNumber="option.fixedNumber" :centerBox="option.centerBox" :infoTrue="option.infoTrue"
                        :fixedBox="option.fixedBox" :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"
                        @cropMoving="cropMoving" @realTime="getCropImg" />
                </div>
            </div>
            <div class="action-box">
                <!-- <el-upload class="upload-demo"
                   action=""
                   :auto-upload="false"
                   :show-file-list="false"
                   :on-change='handleChangeUpload'>
            <el-button type="primary" plain>更换图片</el-button>
        </el-upload> -->
                <el-button type="primary" plain @click="clearImgHandle">清除图片</el-button>
                <el-button type="primary" plain @click="rotateLeftHandle">左旋转</el-button>
                <el-button type="primary" plain @click="rotateRightHandle">右旋转</el-button>
                <el-button type="primary" plain @click="changeScaleHandle(1)">放大</el-button>
                <el-button type="primary" plain @click="changeScaleHandle(-1)">缩小</el-button>
                <el-button type="primary" plain @click="downloadHandle('blob')">下载</el-button>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelImg">取 消</el-button>
                <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { httpService, srcUrl, videoUrl } from "@/service/httpService";
import wangEditor from 'wangeditor'
import MyCropper from 'vue-cropper'
export default {
    components: { MyCropper },
    data() {
        return {
            srcUrl: srcUrl,
            videoUrl: videoUrl,
            actionUrl: process.env.VUE_APP_GATEWAY + '/upload/addfile',
            ruleForm: {
                titleImgUrl: '',
                pressTime: null,
                pressSuperClass: '',
                pressSource: '',
                // resource: '',
                downloadAttachment: "",
                pressTopic: '',
                synopsis: '',
                content: ''
            },
            rules: {
                titleImgUrl: [
                    { required: true, message: '请上传图片', trigger: 'change' }
                ],
                pressTopic: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                ],
                pressTime: [
                    { required: true, message: '请选择日期', trigger: 'change' }
                ],
                pressSuperClass: [
                    { required: true, message: '请选择发布栏目', trigger: 'change' }
                ],
                pressSource: [
                    { required: true, message: '请输入创建者（来源）', trigger: 'blur' },
                ],

                resource: [
                    { required: true, message: '请选择是否发布到首页', trigger: 'change' }
                ],
                synopsis: [
                    { required: true, message: '请填写简介', trigger: 'blur' }
                ],
                content: [
                    { required: true, message: '请输入详情', trigger: 'blur' },
                ],
            },
            editor: null,
            editorData: '',
            header: null,
            titleImgUrlList: [],
            imgfileList: [],
            fileList: [],
            pickerOptions: {
                disabledDate: this.disabledDate
            },
            pressSuperClassArr: [],
            id: '',
            isPreview: false,
            dialogVisible: false,
            previewImg: '', // 预览图片地址
            // 裁剪组件的基础配置option
            option: {
                img: 'https://pic1.zhimg.com/80/v2-366c0aeae2b4050fa2fcbfc09c74aad4_720w.jpg', // 裁剪图片的地址
                info: true, // 裁剪框的大小信息
                outputSize: 1, // 裁剪生成图片的质量
                outputType: 'png', // 裁剪生成图片的格式
                canScale: true, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                canMoveBox: true, // 截图框能否拖动
                autoCropWidth: 200, // 默认生成截图框宽度
                autoCropHeight: 200, // 默认生成截图框高度
                fixedBox: false, // 固定截图框大小 不允许改变
                fixed: true, // 是否开启截图框宽高固定比例
                fixedNumber: [4, 3], // 截图框的宽高比例
                full: false, // 是否输出原图比例的截图
                original: false, // 上传图片按照原始比例渲染
                centerBox: false, // 截图框是否被限制在图片里面
                infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            },
            // 防止重复提交
            loading: false,
            imgFile: '',
            showImg: false
        }
    },
    created() {
        // 修改新闻
        this.id = this.$route.query.id || this.$route.params.id;
        if (this.id) {
            this.getNews(this.id)
        }
        this.getpressSuperClass()

    },

    mounted() {
        //  创建富文本
        const editor = new wangEditor(`#edit`)
        // 配置 onchange 回调函数，将数据同步到 vue 中
        editor.config.onchange = (newHtml) => {
            this.editorData = newHtml
        }
        // 配置 server 接口地址
        editor.config.uploadImgServer = `${process.env.VUE_APP_GATEWAY}/upload/addfileCichText`
        editor.config.uploadFileName = 'file'
        //  maxFileSize: 10 * 1024 * 1024,
        editor.config.uploadImgShowBase64 = true //可使用 base64 格式保存图片。即，可选择本地图片，编辑器用 base64 格式显示图片。
        // editor.config.showLinkImg = false 即可隐藏插入网络图片的功能，即只保留上传本地图片。
        // 配置 视频server 接口地址
        editor.config.uploadVideoServer = `${process.env.VUE_APP_GATEWAY}/upload/addfileCichText`
        editor.config.uploadVideoName = 'file'
        //  editor.config.showLinkVideo = false 即可隐藏插入网络视频的功能，即只保留上传本地视频。
        // 创建编辑器
        editor.config.uploadImgHooks = {
            fail: (xhr, editor, result) => {
                // 插入图片失败回调
                this.$message(result)
            },
            success: (xhr, editor, result) => {
                // 图片上传成功回调
                this.$message(result)
            },
            timeout: (xhr, editor) => {
                // 网络超时的回调
                this.$message('网络超时')
            },
            error: (xhr, editor) => {
                // 图片上传错误的回调
                this.$message('上传错误')
            },
            //回显
            customInsert: (insertImg, result, editor) => {
                let url = srcUrl + result.result[0].url
                insertImg(url);
            },
        };
        // 视频
        editor.config.uploadVideoHooks = {
            fail: (xhr, editor, result) => {
                // 插入图片失败回调
                this.$message(result)

            },
            success: (xhr, editor, result) => {
                // 图片上传成功回调
                this.$message(result)
            },
            timeout: (xhr, editor) => {
                // 网络超时的回调
                this.$message('网络超时')
            },
            error: (xhr, editor) => {
                // 图片上传错误的回调
                this.$message('上传错误')
            },
            //回显
            customInsert: (insertImg, result, editor) => {
                let url = videoUrl + result.result[0].url
                insertImg(url);
            },
        };
        // editor.create();
        editor.txt.html(this.value);
        editor.create()
        this.editor = editor
        // 结束预览渲染表单
        if (JSON.parse(sessionStorage.getItem("formdata"))) {
            this.ruleForm = JSON.parse(sessionStorage.getItem("formdata"))
            if (this.ruleForm.titleImgUrl) {
                this.imgfileList = [
                    { url: srcUrl + this.ruleForm.titleImgUrl, name: this.ruleForm.titleImgUrl }
                ]
            }
        }
        // this.header = {
        //     'X-Authorization': 'Bearer ' + this.token
        // }
        setTimeout(() => {
            if (this.imgfileList.length > 0) {
                document.querySelector('.el-upload--picture-card').style.display = 'none'
                this.showImg = true
            }
            if (this.ruleForm.content) {
                editor.txt.html(this.ruleForm.content)
            }
        }, 500);
    },

    methods: {
        // 获取编辑的新闻
        async getNews(id) {
            let data = await httpService.membergetNews(id);
            if (data.code == 200) {
                this.ruleForm = data.result
                this.imgfileList = [
                    { url: srcUrl + this.ruleForm.titleImgUrl, name: this.ruleForm.titleImgUrl }
                ]
                if (this.imgfileList.length > 0) {
                    document.querySelector('.el-upload--picture-card').style.display = 'none'
                }
                let filearr = []
                if (this.ruleForm.downloadAttachment) {
                    filearr = this.ruleForm.downloadAttachment.split(',');
                    filearr = filearr.map((item, index) => {
                        return {
                            url: srcUrl + item,
                            uid: index,
                            name: item
                        };
                    });
                }
                this.fileList = filearr
                // if (this.ruleForm.content) {
                //     editor.txt.html(this.ruleForm.content)
                // }
            }
        },
        // 重置
        resetForm() {
            this.$refs['ruleForm'].resetFields();
            this.fileList = []
            this.imgfileList = []
            if (this.imgfileList.length == 0) {
                document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'inline-block'
            }
            this.editor.txt.html('')
        },
        //获取发布栏目
        getpressSuperClass() {
            httpService.getALLColumn().then(res => {
                if (res.code == 200) {
                    this.pressSuperClassArr = res.result[0].children
                }
            })
        },
        submitForm(formName) {
            this.ruleForm.content = this.editor.txt.html()
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.audit = 0;//0保存99草稿
                    this.ruleForm.content = this.editor.txt.html()
                    if (this.fileList.length != 0) {
                        let filearr = []
                        this.fileList.map(ele => {
                            if (ele.response) {
                                filearr.push(ele.response.result)

                            } else {
                                filearr.push(ele.name)
                            }
                        })
                        this.ruleForm.downloadAttachment = filearr.join(',')
                    }
                    if (this.id) {
                        // 修改新闻
                        httpService.updateNews(this.ruleForm).then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    message: '发布成功',
                                    type: 'success'
                                });
                                this.resetForm()
                            } else {
                                this.$message.error(res.message);
                            }
                        })
                    } else {
                        httpService.addNews(this.ruleForm).then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    message: '发布成功',
                                    type: 'success'
                                });
                                this.resetForm()
                                sessionStorage.removeItem('formdata')
                            } else {
                                this.$message.error(res.message);
                            }
                        })
                    }

                } else {
                    return false;
                }
            });
        },
        draftForm() {
            this.ruleForm.content = this.editor.txt.html()
            if (this.fileList.length != 0) {
                let filearr = []
                this.fileList.map(ele => {
                    if (ele.response) {
                        filearr.push(ele.response.result)

                    } else {
                        filearr.push(ele.name)
                    }
                })
                this.ruleForm.downloadAttachment = filearr.join(',')
            }
            if (!this.ruleForm.titleImgUrl || !this.ruleForm.pressSuperClass || !this.ruleForm.pressSource || !this.ruleForm.pressTopic) {
                this.$message({
                    message: '标题图片、发布栏目、创建者（来源）、标题四项为保存草稿必填项,请检查是否填写完整',
                    type: 'warning'
                });
                return
            }
            else {
                this.ruleForm.audit = 99
                if (this.id) {
                    // 修改新闻
                    httpService.updateNews(this.ruleForm).then(res => {
                        if (res.code == 200) {
                            this.$message({
                                message: '草稿编辑保存成功',
                                type: 'success'
                            });
                            // this.resetForm()
                            // let arr=[]
                            // let obj
                            // arr.forEach(ele=>{

                            // })
                            sessionStorage.removeItem('formdata')
                        } else {
                            this.$message.error(res.message);
                        }

                    })
                } else {
                    httpService.addNews(this.ruleForm).then(res => {
                        if (res.code == 200) {
                            this.$message({
                                message: '草稿保存成功',
                                type: 'success'
                            });
                            // this.resetForm()
                            sessionStorage.removeItem('formdata')
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                }

            }
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        // // 获取富文本内容
        // getEditorData() {
        //     // 通过代码获取编辑器内容
        //     let data = this.editor.txt.html()
        //     alert(data)
        // }
        // 返回列表
        returnListFn() {
            // this.$emit('offAddNewsFn', '列表')
            this.$router.push('/account-center/info-release');
            sessionStorage.removeItem('formdata')
        },
        previewFn(file, fileList) {
            this.ruleForm.content = this.editor.txt.html()
            sessionStorage.setItem("formdata", JSON.stringify(this.ruleForm));
            //   sessionStorage.removeItem("site");
            this.$router.push('/account-center/perview-news');
        },
        // 图片上传
        // handleAvatarSuccess(res, file, fileList) {
        //     //  const isLt2M = file.size / 1024 / 1024 < 2;
        //     // if (!isLt2M) {
        //     //     this.$message.error('上传图片大小不能超过 2MB!');
        //     //     return false
        //     // }
        //     if (res.code == 200) {
        //         this.imgfileList = fileList
        //         this.ruleForm.titleImgUrl = res.result
        //         if (this.imgfileList.length > 0) {
        //             document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'none'
        //         }
        //         this.$nextTick(async () => {
        //             // base64方式
        //             // this.option.img = await fileByBase64(file.raw)
        //             this.option.img = URL.createObjectURL(file.raw)
        //             this.loading = false
        //             this.dialogVisible = true
        //         })
        //     }

        // },
        //上传图片时会被调用
        changePhotoFile(file, fileList) {
            this.$nextTick(async () => {
                // base64方式
                // this.option.img = await fileByBase64(file.raw)
                this.option.img = URL.createObjectURL(file.raw)
                this.loading = false
                this.dialogVisible = true;
            })
        },
        // 放大/缩小
        changeScaleHandle(num) {
            num = num || 1;
            this.$refs.cropper.changeScale(num);
        },
        // 左旋转
        rotateLeftHandle() {
            this.$refs.cropper.rotateLeft();
        },
        // 右旋转
        rotateRightHandle() {
            this.$refs.cropper.rotateRight();
        },
        // 下载
        downloadHandle(type) {
            let aLink = document.createElement('a')
            aLink.download = 'author-img'
            if (type === 'blob') {
                this.$refs.cropper.getCropBlob((data) => {
                    let downImg = window.URL.createObjectURL(data)
                    aLink.href = window.URL.createObjectURL(data)
                    aLink.click()
                })
            } else {
                this.$refs.cropper.getCropData((data) => {
                    let downImg = data;
                    aLink.href = data;
                    aLink.click()
                })
            }
        },
        // 清理图片
        clearImgHandle() {
            this.option.img = ''
        },
        // 截图框移动回调函数
        cropMoving(data) {
            // 截图框的左上角 x，y和右下角坐标x，y
            // let cropAxis = [data.axis.x1, data.axis.y1, data.axis.x2, data.axis.y2]
            // console.log(cropAxis)
        },
        getCropImg() {
            if (this.option.outputType === "blob") {
                this.$refs.cropper.getCropBlob(data => {
                    // var img = window.URL.createObjectURL(data);
                    var img = data;
                    this.imgFile = img;
                });
            } else {
                this.$refs.cropper.getCropData(data => {
                    this.imgFile = data;
                    this.imgFile = this.base64ToFile(data, 'docpic.jpg')
                });
            }
        },
        base64ToFile(urlData, fileName) {
            let arr = urlData.split(',');
            let mime = arr[0].match(/:(.*?);/)[1];
            let bytes = atob(arr[1]); // 解码base64
            let n = bytes.length
            let ia = new Uint8Array(n);
            while (n--) {
                ia[n] = bytes.charCodeAt(n);
            }
            return new File([ia], fileName, { type: mime });
        },
        finish() {
            // 获取截图的 blob 数据
            this.$refs.cropper.getCropBlob((blob) => {
                this.loading = true
                this.dialogVisible = false
                this.previewImg = URL.createObjectURL(blob)
                this.isPreview = true
                this.$refs.cropper.getCropBlob((blob) => {
                    const formData = new FormData();
                    formData.append("file", this.imgFile)
                    httpService.addfile(formData).then(res => {
                        if (res.code == 200) {
                            this.imgfileList = [
                                { url: srcUrl + res.result, name: res.result }
                            ]
                            this.showImg = true
                            this.ruleForm.titleImgUrl = res.result
                            if (this.imgfileList.length > 0) {
                                document.querySelector('.el-upload--picture-card').style.display = 'none'
                            }
                        }
                    })
                });
            })
            // 获取截图的 base64 数据
            // this.$refs.cropper.getCropData(data => {
            //     console.log(data)
            // })
        },
        cancelImg() {
            //  this.showImg=false
            //  document.querySelector('#imgupload').firstChild.firstChild.style.display = 'none'
            this.dialogVisible = false
            //  let remomvList= document.querySelector('#imgupload').firstChild
            //  remomvList.removeChild(remomvList.childNodes[0])
            //   document.querySelector('#imgupload').firstChild.removeChild(remomv)
            // document.querySelector('#imgupload').firstChild.firstChild.style.display = 'inline-block'
            //  document.querySelector('.el-upload--picture-card').style.display = 'inline-block'
            const formData = new FormData();
            formData.append("file", this.imgFile)
            httpService.addfile(formData).then(res => {
                if (res.code == 200) {
                    this.imgfileList = [
                        { url: srcUrl + res.result, name: res.result }
                    ]
                    this.showImg = true
                    this.ruleForm.titleImgUrl = res.result
                    if (this.imgfileList.length > 0) {
                        document.querySelector('.el-upload--picture-card').style.display = 'none'
                    }
                }
            })
        },
        // 删除
        handleRemove(file, fileList) {
            this.imgfileList = []
            if (this.imgfileList.length == 0) {
                document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'inline-block'
            }
        },
        // 文件
        handlefileSuccess(res, file, fileList) {
            if (res.code == 200) {
                this.fileList = fileList
            }
        },
        handlefileRemove(file, fileList) {
            this.fileList = fileList
        },

        disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7
        },

    },
    // beforeDestroy() {
    //     // 调用销毁 API 对当前编辑器实例进行销毁
    //     this.editor.destroy()
    //     this.editor = null
    // }
}
</script>
<style lang="less" scoped>
.AddInfoNewsWarp {
	padding: 30px 400px 20px 80px;
	.addnewseForm {
		.formtop {
			display: flex;
			flex-direction: row;
		}
		.edithome {
			width: 100%;
			margin: auto;
			position: relative;
			z-index: 0;
			.btn {
				position: absolute;
				right: 0;
				top: 0;
				padding: 5px 10px;
				cursor: pointer;
			}
			h3 {
				margin: 30px 0 15px;
			}
		}
		.handleBox {
			// width: 676px;
			margin: 10px auto 0 130px;
			display: flex;
			flex-direction: row;
			justify-content: center;
			.el-button {
				width: 152px;
				height: 40px;
				border-radius: 5px;
				border: none;
				color: #fff;
				margin: 0 15px;
				&:nth-child(1) {
					background: #5cdf7a;

					box-shadow: 0px 2px 10px #5cdf7a;
				}
				&:nth-child(2) {
					background: #0083ff;
					box-shadow: 0px 2px 10px #0083ff;
				}
				&:nth-child(3) {
					background: #ffc56d;
					box-shadow: 0px 2px 10px #ffc56d;
				}
				&:nth-child(4) {
					border: 1px solid #e8e8e8;
					box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.03);
					color: #a6a9b7;
				}
			}
		}
	}
}
.cropper-content {
	.cropper {
		width: auto;
		height: 350px;
	}
}
</style>